import { Grid, Button, TextField, MenuItem } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import React from "react";
import { Trans } from "react-i18next";

export default class Notificateur extends React.Component {
  constructor(properties) {
    super(properties);
    if (
      properties.data !== undefined &&
      Object.keys(properties.data).length !== 0
    ) {
      this.state = {
        data: {
          profession: properties.data.profession,
          professionAutre: properties.data.professionAutre,
          nom: properties.data.nom,
          email: properties.data.email,
          adresse: properties.data.adresse,
          codePostal: properties.data.codePostal,
          commune: properties.data.commune,
          telephone: properties.data.telephone,
          date: properties.data.date,
        },
        errorIncomplete: false,
      };
    } else {
      this.state = {
        data: {
          profession: "",
          professionAutre: null,
          nom: "",
          email: "",
          adresse: "",
          codePostal: "",
          commune: "",
          telephone: "",
          date: null,
        },
        errorIncomplete: false,
      };
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
    this.handleChangeDate = this.handleChangeDate.bind(this);

    window.scrollTo(0, 0);
  }

  handleChangeDate(event_) {
    this.setState({ data: { ...this.state.data, date: event_ } });
  }

  handleChangeDropdown(event_) {
    const { data } = this.state;
    if (event_.target.value === "Autre") {
      this.setState({
        data: { ...data, profession: event_.target.value, professionAutre: "" },
      });
    } else {
      this.setState({
        data: {
          ...data,
          profession: event_.target.value,
          professionAutre: null,
        },
      });
    }
  }

  handleChange(event_) {
    const { data } = this.state;
    switch (event_.target.id) {
      case "nom":
        this.setState({
          data: { ...data, nom: event_.target.value },
          errorIncomplete: false,
        });
        break;
      case "professionAutre":
        this.setState({
          data: { ...data, professionAutre: event_.target.value },
          errorIncomplete: false,
        });
        break;
      case "prenom":
        this.setState({
          data: { ...data, prenom: event_.target.value },
          errorIncomplete: false,
        });
        break;
      case "adresse":
        this.setState({
          data: { ...data, adresse: event_.target.value },
          errorIncomplete: false,
        });
        break;
      case "codePostal":
        this.setState({
          data: { ...data, codePostal: event_.target.value },
          errorIncomplete: false,
        });
        break;
      case "commune":
        this.setState({
          data: { ...data, commune: event_.target.value },
          errorIncomplete: false,
        });
        break;
      case "email":
        this.setState({
          data: { ...data, email: event_.target.value },
          errorIncomplete: false,
        });
        break;
      case "telephone":
        this.setState({
          data: { ...data, telephone: event_.target.value },
          errorIncomplete: false,
        });
        break;
      default:
        break;
    }
  }

  onSubmit() {
    const { data } = this.state;
    if (
      (data.profession !== "" &&
        data.profession === "Autre" &&
        data.professionAutre !== null &&
        data.professionAutre !== "") ||
      data.profession !== "Autre"
    ) {
      this.props.handler(this.state.data);
    } else {
      window.scrollTo(0, 0);
      this.setState({ errorIncomplete: false });
    }
  }

  render() {
    const { data, errorIncomplete } = this.state;
    const { page } = this.props;
    const width = page.toString() + "%";
    return (
      <>
        <p className="pageTitle">Notificateur</p>
        <div className="lineVectors">
          <hr className="lineVector" style={{ width }} />
          <hr className="lineVectorFull" />
        </div>
        {errorIncomplete ? <p className="errorText">Champs manquants</p> : null}

        <div className="inputForm">
          <Grid className="formRowDouble">
            <TextField
              fullWidth
              id="profession"
              select
              value={data.profession}
              onChange={this.handleChangeDropdown}
              label="Profession *"
            >
              <MenuItem value="Médecin">Médecin</MenuItem>
              <MenuItem value="Chirurgien-Dentiste">
                Chirurgien-Dentiste
              </MenuItem>
              <MenuItem value="Pharmacien">Pharmacien</MenuItem>
              <MenuItem value="Sage-Femme">Sage-Femme</MenuItem>
              <MenuItem value="Autre">Autre</MenuItem>
            </TextField>
            {data.profession === "Autre" ? (
              <TextField
                fullWidth
                id="professionAutre"
                type="text"
                value={data.professionAutre}
                onChange={this.handleChange}
                label="Précisez"
              />
            ) : null}
          </Grid>
          <TextField
            fullWidth
            id="nom"
            type="text"
            value={data.nom}
            onChange={this.handleChange}
            label="Nom"
          />
          <TextField
            fullWidth
            id="adresse"
            type="text"
            value={data.adresse}
            onChange={this.handleChange}
            label="Adresse"
          />

          <div className="inputSmallRow">
            <TextField
              id="codePostal"
              className="inputSmall"
              type="number"
              value={data.codePostal}
              onChange={this.handleChange}
              label="Code Postal"
            />
            <TextField
              id="commune"
              className="inputSmall"
              type="text"
              value={data.commune}
              onChange={this.handleChange}
              label="Commune"
            />
          </div>
          <TextField
            fullWidth
            id="telephone"
            type="number"
            value={data.telephone}
            onChange={this.handleChange}
            label="Téléphone"
          />
          <TextField
            fullWidth
            id="email"
            type="text"
            value={data.email}
            onChange={this.handleChange}
            label="Email"
          />
          <DesktopDatePicker
            id="date"
            inputFormat="DD/MM/YYYY"
            value={data.date}
            onChange={this.handleChangeDate}
            label="Date d'établissement de la demande"
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  error={
                    errorIncomplete &&
                    (data.date === null ||
                      !data.date.isValid() ||
                      !data.date.isBefore())
                  }
                />
              );
            }}
          />
        </div>
        <p className="requiredMessage">
          <Trans>* Champs obligatoires</Trans>
        </p>
        <Grid textAlign={"end"} marginBottom="24px" marginTop="24px">
          <Button
            variant="contained"
            disabled={
              data.profession === "" ||
              (data.profession === "Autre" &&
                (data.professionAutre === null || data.professionAutre === ""))
            }
            onClick={() => this.onSubmit()}
          >
            {"SUIVANT"}
          </Button>
        </Grid>
      </>
    );
  }
}
